import { HttpHandlerFn, HttpRequest } from '@angular/common/http';

import { ApiConfig } from './types/api-config.type';

export const apiBaseUrlInterceptorFactory = ({ name, version }: ApiConfig) => {
  const baseUrl = `/${name}/api/v${version}`;

  return (req: HttpRequest<unknown>, next: HttpHandlerFn) => next(req.clone({ url: baseUrl + req.url }));
};
